import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {TimeClockService} from '../../../core/services/time-clock.service';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {BaseTaskRes, ProjectMinRes} from '../../../core/contracts/v0/crm';
import {RestApiService} from '../../../core/services/rest-api.service';
import {BaseCollectionModel, YascOptionItem} from '@yasc/yasc-material-components';
import {DatePipe} from '@angular/common';
import {ProjectController} from '../../../core/controllers/crm/project.controller';

@Component({
    providers: [DatePipe],
    selector: 'cp-time-clock-dialog',
    templateUrl: './time-clock-dialog.component.html',
    styleUrl: './time-clock-dialog.component.scss',
    standalone: false
})
export class TimeClockDialogComponent implements OnInit {
    currentTimer: Date | null = null;
    projects: YascOptionItem<ProjectMinRes>[] = []
    tasks: YascOptionItem<BaseTaskRes>[] = []
    toDelete: number | null = null;

    getTasks(proj: ProjectMinRes) {
        this.tasks = [];
        // TODO: fix
        // if (this.timeClock.selectedProject == null) this.tasks = []
        // else this.tasks = proj.tasks.map(value => new YascOptionItem(value.name!, value))
    }

    constructor(
        @Inject(L10N_LOCALE) public locale: L10nLocale,
        public timeClock: TimeClockService,
        private projectController: ProjectController,
        public restApi: RestApiService,
        public dialogRef: MatDialogRef<TimeClockDialogComponent>,) {
        this.currentTimer = new Date(timeClock.currentTime);
    }

    compare: (a: any, b: any) => boolean = (a, b) => a.id === b.id

    ngOnInit() {
        this.timeClock.ticks.subscribe(tick => this.currentTimer = new Date(tick));
        this.projectController.loadData().then((projects) => {
            this.projects = projects.data.map(x => new YascOptionItem(x.name, x))
        })
        this.timeClock.reset.subscribe(() => this.currentTimer = new Date(0))
    }

    time = (date: Date): string => {
        return this.addZero(date.getUTCHours()) + ':' + this.addZero(date.getUTCMinutes()) + ':' + this.addZero(date.getUTCSeconds());
    }

    addZero(num: number): string {
        return (num < 10 ? '0' : '') + num
    }

    disableSave(): boolean {
        return this.timeClock.selectedTasks === null || this.timeClock.isUnder15Mis()
    }
}